import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    top: '6',
    right: '6',
    w: '6',
    h: '6',
  },
};
